import React from "react";
import DashboardModuleAdapter from "components/context-navigation/DashboardModuleAdapter";
import DPATModuleAdapter from "components/context-navigation/DPATModuleAdapter";
import TrackersModuleAdapter from "components/context-navigation/TrackersModuleAdapter";
import PerformanceAssessmentModuleAdapter from "components/context-navigation/PerformanceAssessment/PerformanceAssessmentModuleAdapter";
import PerformanceMonitoringModuleAdapter from "components/context-navigation/PerformanceAssessment/PerformanceMonitoringModuleAdapter";
import ConsolidatedMonitoringModuleAdapter from "components/context-navigation/ConsolidatedMonitoringModuleAdapter";
import AprDashboard from "pages/apr-dashboard";
import DpatDashboard from "pages/dpat-dashboard";
import DpatPetitionsPage from "pages/dpat-petitions";
import ProgressReport from "pages/progress-report";
import OrganizationalHierarchy from "pages/organizational-hierarchy";
import AutomatedReportGenerationSystem from "pages/automated-report-generation-system";
import RCCProgressReport from "pages/rcc-progress-report";
import SettingsPage from "pages/settings";
import UsersAccessPage from "pages/users-access";
import OhlgsRegionalPage, { OhlgsDistrictPage } from "components/context-navigation/OhlgsR";
import OhlgsConsolidatedChapterOne from "components/context-navigation/OhlgsConsolidatedChapterOne";

/**
 * Maps context module slugs to render functions.
 * Keep in sync with CONTEXT_MODULES in contextModules.js.
 */
export function renderContextModule(moduleSlug, { level }) {
  switch (moduleSlug) {
    case "dashboard":
    case "national-dashboard":
    case "regional-dashboard":
    case "district-dashboard":
      return <DashboardModuleAdapter />;

    case "dpat-assessment":
      return <DPATModuleAdapter />;

    case "performance-assessment":
      return <PerformanceAssessmentModuleAdapter />;

    case "performance-monitoring":
      return <PerformanceMonitoringModuleAdapter />;

    case "consolidated-monitoring":
      return <ConsolidatedMonitoringModuleAdapter />;

    case "trackers":
      return <TrackersModuleAdapter />;

    case "reports":
      return <AprDashboard />;

    case "dpat-dashboard":
      return <DpatDashboard />;

    case "dpat-petitions":
      return <DpatPetitionsPage />;

    case "progress-report":
      return <ProgressReport />;

    case "rcc-progress-report":
      return <RCCProgressReport />;

    case "rcc":
      return <OrganizationalHierarchy />;

    case "ohlgs-report":
      return level === "district" ? <OhlgsDistrictPage /> : <AutomatedReportGenerationSystem />;

    case "ohlgs-regional-report":
      return <OhlgsRegionalPage />;

    case "ohlgs-consolidated":
      return <OhlgsConsolidatedChapterOne />;

    case "settings":
      return <SettingsPage />;

    case "users-access":
      return <UsersAccessPage />;

    default:
      return null;
  }
}
